export class AppHeaders {
    public static AUTHORIZATION = "Authorization";
}
